module.exports = "/wwwroot/img/sub_theme_page.png?ver=d142dcf4";